import * as Sentry from '@sentry/react';

import { shouldDropEvent } from './beforeSend';
import { resolveEnvironment } from './environment';

export { requestErrorMiddleware } from './requestErrorMiddleware';

/**
 * Initialises Sentry error monitoring. Called once from the app entry point
 * before React renders. Enabled only in production — where the bugs this flow
 * reacts to actually happen — so staging and feature envs don't add noise.
 * No-ops everywhere else (incl. localhost) and when no DSN is set, unless
 * REACT_APP_SENTRY_FORCE_LOCAL=true (set that to test end-to-end).
 */
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = resolveEnvironment(window.location.hostname);
  const forceLocal = process.env.REACT_APP_SENTRY_FORCE_LOCAL === 'true';
  const enabled = Boolean(dsn) && (environment === 'production' || forceLocal);

  if (!enabled) {
    return;
  }

  Sentry.init({
    dsn,
    environment,
    enabled,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    // Error monitoring only — no performance tracing or session replay (matches
    // the lean merchant-web setup; both add cost/noise for an internal tool).
    beforeSend: event => (shouldDropEvent(event) ? null : event),
  });
}
